import { PropertyMappingEntityEnum, TemplateModel } from '../../shared/models';
import { DefaultPropertiesBuilder } from './default-properties-builder';
import { Property, PropertyTypeEnum } from './types';

export type TemplatePropertyKey = keyof Omit<
  TemplateModel,
  'rules' | 'workspace' | 'workspaceId'
>;

export const getTemplateDefaultPropertiesDefinition = (): Record<
  TemplatePropertyKey,
  Property<PropertyTypeEnum>
> =>
  new DefaultPropertiesBuilder<TemplateModel>(PropertyMappingEntityEnum.case)
    .addProperty('id', PropertyTypeEnum.text)
    .addProperty('name', PropertyTypeEnum.text)
    .addProperty('description', PropertyTypeEnum.text)
    .addProperty('isDefault', PropertyTypeEnum.boolean)
    .addProperty('mergeIdentityChecks', PropertyTypeEnum.boolean)
    .addProperty('caseAutoApproval', PropertyTypeEnum.boolean)
    .addProperty('caseAutoReopening', PropertyTypeEnum.boolean)
    .addProperty('autoRejectProhibitedRisk', PropertyTypeEnum.boolean)
    .addProperty(
      'caseReviewApprovalEnforceAllControlsCompleted',
      PropertyTypeEnum.boolean,
    )
    .addProperty('createdAt', PropertyTypeEnum.date)
    .addProperty('updatedAt', PropertyTypeEnum.date)
    .getDefinition();
